<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 181.517 181.517">
        <g id="Groupe_3192" data-name="Groupe 3192" transform="translate(-14429 -5550)">
            <circle id="Ellipse_1608" data-name="Ellipse 1608" cx="90.758" cy="90.758" r="90.758" transform="translate(14429 5550)" :fill="color" opacity="0.05"/>
            <circle id="Ellipse_1609" data-name="Ellipse 1609" cx="76.796" cy="76.796" r="76.796" transform="translate(14442.963 5563.963)" :fill="color" opacity="0.05"/>
            <circle id="Ellipse_1610" data-name="Ellipse 1610" cx="62.833" cy="62.833" r="62.833" transform="translate(14456.926 5577.926)" :fill="color" opacity="0.05"/>
            <g id="noun_attention_1013229" transform="translate(14491.274 5611.927)">
                <path id="Tracé_559" data-name="Tracé 559" d="M1.441,57.636a1.441,1.441,0,0,1-1.366-1.9l4.06-12.048A28.831,28.831,0,1,1,13.949,53.5L1.9,57.56A1.437,1.437,0,0,1,1.441,57.636Zm12.691-7.159a1.439,1.439,0,0,1,.774.226,25.952,25.952,0,1,0-7.973-7.974,1.444,1.444,0,0,1,.15,1.235L3.734,53.9l9.938-3.349A1.432,1.432,0,0,1,14.132,50.477Z" transform="translate(0.001 0)" :fill="color"/>
                <ellipse id="Ellipse_975" data-name="Ellipse 975" cx="1.441" cy="1.441" rx="1.441" ry="1.441" transform="translate(27.378 41.732)" :fill="color"/>
                <path id="Tracé_560" data-name="Tracé 560" d="M48.941,48.751A1.441,1.441,0,0,1,47.5,47.31V25.535a1.441,1.441,0,0,1,2.882,0V47.31A1.441,1.441,0,0,1,48.941,48.751Z" transform="translate(-20.122 -10.207)" :fill="color"/>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ArtWarning',
    mixins: [Colorable],
};
</script>
